import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { apiUrls } from 'app/shared/constants/apiUrls';
import { environment } from 'environments/environment';

@Injectable()
export class AnalyticsDashboardService implements Resolve<any>
{
    widgets: any[];
    TenantList: any[];
    onUserChanged: BehaviorSubject<any>;
    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private _httpClient: HttpClient
    )
    { this.onUserChanged = new BehaviorSubject({});
    }

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        return new Promise<void>((resolve, reject) => {

            Promise.all([
                this.getWidgets()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Get widgets
     *
     * @returns {Promise<any>}
     */
    getWidgets(): Promise<any>
    {
        return new Promise((resolve, reject) => {
            this._httpClient.get('api/analytics-dashboard-widgets')
                .subscribe((response: any) => {
                    this.widgets = response;
                    resolve(response);
                }, reject);
        });
    }

    getUsersTenant(tenantId): Promise<any> {
        return new Promise((resolve, reject) => {
            let headers: HttpHeaders = new HttpHeaders();
            headers = headers.append("Authorization" , "Basic YWRtaW46UGEkJFdvUmQ=");
            this._httpClient.get(environment.IdentityUrl2 + apiUrls.Report + '/Tenant/' + tenantId,{headers : headers})
                .subscribe((response: any) => {
                    this.TenantList = response;
                    this.onUserChanged.next(this.TenantList);
                    resolve(response);
                }, reject); 
        });
    }
}
